export enum ContentStatus {
    Draft = "Draft",
    Published = "Published"
}